import script from "./StudyDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./StudyDetail.vue?vue&type=script&setup=true&lang=js"

import "./StudyDetail.vue?vue&type=style&index=0&id=62798788&lang=scss"

const __exports__ = script;

export default __exports__